import { createContext } from 'react';

interface TopBarContextType {
  content: string;
  brandFlairs: Array<any>;
  productFlairs: Array<any>;
  brandFlairsIdentifier: Array<any>;
  collections: Array<any>;
  categories: Array<any>;
  getFlairs: () => void;
  getCollections: () => void;
  getCategories: () => void;
}

const TopBarContext = createContext<TopBarContextType>({
  content: '',
  brandFlairs: [],
  productFlairs: [],
  brandFlairsIdentifier: [],
  collections: [],
  categories: [],
  getFlairs: () => {},
  getCollections: () => {},
  getCategories: () => {},
});

export default TopBarContext;
